import { CharityFormsActionTypes, CharityFormsActions } from './charity-forms.actions';
import { ICharityForms } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: ICharityForms | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: CharityFormsActions): State {
    switch (action.type) {

        case CharityFormsActionTypes.LoadCharityFormsState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case CharityFormsActionTypes.LoadCharityFormsStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case CharityFormsActionTypes.LoadCharityFormsStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case CharityFormsActionTypes.CharityFormsScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;